/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/display-name */
import { IonLabel } from '@ionic/react';
import isEqual from 'lodash/isEqual';
import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { AiOutlineComment } from 'react-icons/ai';
import { BiBlock } from 'react-icons/bi';
import { FiArrowRight, FiFlag, FiSend, FiTrash2, FiX } from 'react-icons/fi';
import { Virtuoso } from 'react-virtuoso';

import {
  Avatar,
  Avatar as ChakraAvatar,
  Button as ChakraButton,
  Icon as ChakraIcon,
  Tooltip as ChakraTooltip,
  Flex,
  IconButton,
  List,
  ListItem,
  Portal,
  Spinner,
  Text,
  Textarea,
  forwardRef,
  useDisclosure,
  FormControl,
  InputRightElement,
  Box,
} from '@chakra-ui/react';
import moment from 'moment';
import { Icon } from 'rsuite';
import { BsChatFill, BsEmojiSmile } from 'react-icons/bs';
import { Picker } from 'emoji-mart';
import {
  GenericComment,
  PromptComment,
  ResponseComment,
  User,
} from '../../@types';
import { useConnections, useCurrentUser, useDeleteComment } from '../../api';
import BlgButton from '../../components/Button/Button';
import * as Constants from '../../constants';
import { FlagContentModal } from '../flag-content';
import { showNotification } from '../notification';
import { ConfirmDeleteDialog } from '../response-inputs';
import { UserProfilePopover } from '../user';
import {
  AddCommentInputError,
  ChatWrapper,
  CommentDate,
  CommentFeedWrapper,
} from './ChatStyles';
import { CommentMedia } from './CommentMedia';
import BlgInput from '../../components/Input';
// import { CommentReplies } from './CommentReplies';
// import { CommentReactions } from './CommentReactions';

const ALLOWED_EMOJIS = Object.entries(Constants.EMOJIS);

export const insertAllowedEmojiPlaceholders = (text: string): string => {
  let replacedText = text;
  ALLOWED_EMOJIS.forEach(([key, data]) => {
    replacedText = replacedText.replace(
      new RegExp(data.unicode, 'gi'),
      data.code
    );
  });
  return replacedText;
};

export const replaceSpaces = (text: string): string => {
  return text.replace(/\s\s+/g, '  ');
};

export const replaceAllowedEmojis = (text: string): string => {
  let replacedText = text;
  ALLOWED_EMOJIS.forEach(([key, data]) => {
    replacedText = replacedText.replace(
      new RegExp(data.code, 'gi'),
      data.unicode
    );
    const unicodeRegex = new RegExp(data.unicode, 'gi');
    replacedText = replacedText.replace(unicodeRegex, `${data.unicode} `);
    replacedText = replaceSpaces(replacedText);
  });
  return replacedText;
};

export const removeUnapprovedEmojis = (text: string): string => {
  return text.replace(
    /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/gi,
    ''
  );
};

export const BlgModalEpisodeQuestionPerson = ({ person, onClick }: any) => {
  return (
    <Flex
      bg="ligthBlue.500"
      _hover={{ bg: 'ligthBlue.600' }}
      cursor="pointer"
      p={4}
      borderRadius={24}
      gap={4}
      onClick={onClick}
      pr={8}
    >
      <Avatar size="lg" />
      <Flex flexDir="column" justifyContent="center">
        <Text fontSize={14} fontWeight={800} position="relative">
          {person.name}{' '}
          {person.isYou && (
            <Text
              position="absolute"
              bg="red.500"
              color="white"
              fontSize={10}
              top={-4}
              right={-6}
              fontWeight={700}
              w={7}
              h={7}
              display="flex"
              justifyContent="center"
              alignItems="center"
              borderRadius="full"
            >
              You
            </Text>
          )}
        </Text>
        <Flex alignItems="center" gap={1}>
          <ChakraIcon as={BsChatFill} />
          <Text fontSize={12} fontWeight={600} mt={1}>
            {person.comments}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

const AvatarButton: React.FC = forwardRef(({ children }, ref) => (
  <ChakraButton rounded="full" size="sm" mx={2} ref={ref} w="auto" p={0}>
    {children}
  </ChakraButton>
));

const UserProfileTrigger = memo(
  ({ username, icon, onClickUserProfile }: any) => (
    <ChakraButton
      rounded="full"
      variant="outline"
      size="sm"
      ml={2}
      mr={3}
      p={1}
      h="40px"
      w="40px"
      borderWidth="2px"
      minW="initial"
      bg="white"
      pointerEvents="none"
      // onClick={onClickUserProfile}
      // sx={{
      //   _hover: {
      //     borderColor: 'blue.500',
      //     '.chakra-avatar__badge': { color: 'blue.500' },
      //   },
      // }}
    >
      <ChakraAvatar
        showBorder
        boxSize={8}
        name={username}
        {...(icon && {
          src: `${Constants.ROOT_URL}/img/${icon.file_name}`,
          bg: 'none',
        })}
      >
        {/* <AvatarBadge color="gray.300" bg="white" p="0px" border="none">
          <ChakraIcon boxSize={4} as={MdPersonSearch} />
        </AvatarBadge> */}
      </ChakraAvatar>
    </ChakraButton>
  ),
  (prevProps, nextProps) => {
    return prevProps.username === nextProps.username;
  }
);
const ChatMessage = memo(
  ({
    comment: _comment,
    lastItem,
    user,
    isModerator,
    chatType,
    onClickUserProfile,
    onStartFlagComment,
    connection,
    commentIndex,
  }: any) => {
    const {
      id,
      replies,
      flag_reports,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      user_id,
      user: commentUser,
      created,
      comment,
      media_src,
      media_type,
      tags,
    } = _comment;
    const { username, user_role_id, icon } = commentUser;
    const commentText = replaceAllowedEmojis(comment);

    const { isOpen, onOpen, onClose } = useDisclosure();
    const {
      mutateAsync: deleteComment,
      isLoading: isDeleting,
    } = useDeleteComment(chatType);

    const isMyComment = user_id === user.id;
    const commentUsername = isMyComment ? (
      <>
        {username} <span className="me">You</span>
      </>
    ) : (
      username
    );
    const canFlagComment =
      isModerator || user_role_id === Constants.USER_ROLES.STUDENT;

    const date_created: any = moment(created).utc().valueOf();
    const commentRelativeDate = moment.unix(date_created / 1000).fromNow(true);

    const onClickFlagComment = useCallback(() => {
      onStartFlagComment({ comment: _comment });
    }, [_comment]);

    const userAlreadyFlagged = !!flag_reports?.length;
    const flagContentLabel = userAlreadyFlagged
      ? 'Your request to flag this content is currently under review.'
      : 'Flag Inappropriate Comment';
    const strippedText = commentText.replace(/<[^>]+>/g, '');

    const onBeginDeleteComment = useCallback(() => {
      onOpen();
    }, [onOpen]);

    const onDeleteComment = useCallback(async () => {
      if (!!isMyComment) {
        const res = await deleteComment({
          comment_id: id,
          comment_type: chatType,
        });
        if (res.success) {
          showNotification({
            type: 'success',
            title: 'Comment Deleted',
            message: 'Your comment was deleted successfully.',
          });
          onClose();
        }
      }
    }, [isMyComment, deleteComment, chatType, id]);

    return (
      <Flex
        align="center"
        w="full"
        borderBottom={lastItem ? 'none' : '1px solid'}
        borderColor="gray.200"
      >
        <ListItem w="full" p="10px 5px">
          <Flex px={2} w="full" justify="space-between" align="center">
            <Flex flexGrow={1} align="center">
              <UserProfileTrigger
                onClickUserProfile={() => onClickUserProfile(commentUser)}
                username={username}
                icon={icon}
              />
              <IonLabel className="ion-text-wrap">
                <h3 className="comment-username">{commentUsername}</h3>
                {media_src && media_type && (
                  <CommentMedia media_src={media_src} media_type={media_type} />
                )}

                <div className="comment-body-text">
                  {tags && <span className="tags">{tags}</span>}
                  <p>{strippedText}</p>
                  <CommentDate>{commentRelativeDate}</CommentDate>
                </div>
              </IonLabel>
            </Flex>
            {!isMyComment ? (
              canFlagComment && (
                <ChakraTooltip
                  bg={userAlreadyFlagged ? 'gray.700' : 'red.500'}
                  p={3}
                  rounded="lg"
                  color="white"
                  fontSize="sm"
                  fontWeight="medium"
                  label={flagContentLabel}
                  placement="left"
                  shouldWrapChildren={userAlreadyFlagged}
                >
                  <IconButton
                    variant="ghost"
                    bg="white"
                    rounded="full"
                    border="1px solid"
                    borderColor="gray.200"
                    size="sm"
                    mr={3}
                    aria-label={flagContentLabel}
                    isDisabled={userAlreadyFlagged}
                    onClick={onClickFlagComment}
                    icon={<ChakraIcon boxSize={4} as={FiFlag} />}
                    color="gray.400"
                    _hover={{
                      color: 'red.600',
                      bg: 'red.50',
                      borderColor: 'red.200',
                    }}
                  />
                </ChakraTooltip>
              )
            ) : (
              <>
                <IconButton
                  variant="ghost"
                  bg="white"
                  rounded="full"
                  border="1px solid"
                  borderColor="gray.200"
                  size="sm"
                  mr={3}
                  aria-label="Delete comment"
                  onClick={onBeginDeleteComment}
                  icon={<ChakraIcon boxSize={4} as={FiTrash2} />}
                  color="gray.400"
                  _hover={{
                    color: 'red.600',
                    bg: 'red.50',
                    borderColor: 'red.200',
                  }}
                />
                {isOpen && (
                  <Portal appendToParentPortal={false}>
                    <ConfirmDeleteDialog
                      isOpen={isOpen}
                      onClose={onClose}
                      onConfirm={onDeleteComment}
                      isLoading={isDeleting}
                      headerText="Delete comment"
                    />
                  </Portal>
                )}
              </>
            )}
          </Flex>
        </ListItem>
      </Flex>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.commentIndex === nextProps.commentIndex &&
      isEqual(prevProps.comment, nextProps.comment) &&
      prevProps.isModerator === nextProps.isModerator &&
      prevProps.lastItem === nextProps.lastItem
    );
  }
);

export const RenderCommentFeed: React.FC<{
  comments: (PromptComment | ResponseComment | GenericComment)[];
  chatType: string;
  isModerator?: boolean;
  connections: any;
  user: User;
}> = ({ comments, chatType, isModerator = false, user, connections }) => {
  const virtuoso = useRef<any>(null);
  const [currentUserProfile, setCurrentUserProfile] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [flaggingComment, setFlaggingComment] = useState<any>(null);

  const {
    isOpen: isFlagModalOpen,
    onOpen: onOpenFlagModal,
    onClose: onCloseFlagModal,
  } = useDisclosure();

  const onStartFlagComment = useCallback(
    ({ comment }: { comment: Record<string, any> }) => {
      setFlaggingComment(comment);
      onOpenFlagModal();
    },
    []
  );

  const onFlagModalClosed = useCallback(() => {
    setFlaggingComment(null);
    onCloseFlagModal();
  }, []);

  const onClickUserProfile = (u: any) => {
    setCurrentUserProfile(u);
    onOpen();
  };

  const findConnection = (userId: any) => {
    const connection =
      (user.id !== userId &&
        connections.active?.find((u: any) => u.id === userId)) ||
      connections.pending?.find((u: any) => u.id === userId) ||
      connections.invites?.find((u: any) => u.id === userId);
    return connection;
  };

  const connectionsHash = useMemo(() => {
    const obj: any = {};
    const uniqueUsers = [
      ...Array.from(new Set(comments.map((c) => c.user_id))),
    ];
    uniqueUsers.forEach((userId) => {
      obj[userId] = findConnection(userId);
    });
    return obj;
  }, [comments.length]);

  const allComments = useMemo(
    () =>
      comments.map((comment, index) => {
        const lastItem = index === comments.length - 1;
        return (
          <ChatMessage
            key={index}
            comment={comment}
            chatType={chatType}
            lastItem={lastItem}
            isModerator={isModerator}
            connection={connectionsHash[comment.user_id]}
            onStartFlagComment={onStartFlagComment}
            user={user}
            commentIndex={index}
            onClickUserProfile={onClickUserProfile}
          />
        );
      }),
    [
      JSON.stringify(comments),
      onStartFlagComment,
      user,
      connectionsHash,
      isModerator,
    ]
  );

  const renderItem = useCallback(
    (index) => {
      return allComments[index];
    },
    [comments]
  );

  const contentFlagTypeMap = {
    sonar: Constants.FLAGGED_CONTENT_TYPES.SONAR_MESSAGE,
    prompt: Constants.FLAGGED_CONTENT_TYPES.PROMPT_COMMENT,
    responses: Constants.FLAGGED_CONTENT_TYPES.RESPONSE_COMMENT,
  };

  return (
    <>
      <CommentFeedWrapper>
        <List w="full" h="100%" p={0}>
          <Virtuoso
            style={{ height: '100%' }}
            totalCount={comments.length}
            ref={virtuoso}
            overscan={450}
            initialTopMostItemIndex={comments.length - 1}
            followOutput="smooth"
            itemContent={renderItem}
          />
        </List>
        <UserProfilePopover
          isOpen={isOpen && currentUserProfile}
          onClose={() => {
            setCurrentUserProfile(null);
            onClose();
          }}
          user={currentUserProfile}
        />
      </CommentFeedWrapper>
      {flaggingComment && (
        <Portal appendToParentPortal={false}>
          <FlagContentModal
            isOpen={isFlagModalOpen}
            onClose={onFlagModalClosed}
            content={flaggingComment}
            contentType={
              contentFlagTypeMap[chatType as keyof typeof contentFlagTypeMap]
            }
            isModerator={isModerator}
          />
        </Portal>
      )}
    </>
  );
};

export const Chat: React.FC<{
  isLoading: boolean;
  isVisible?: boolean;
  isModerator?: boolean;
  comments: [] | GenericComment[];
  canMessage?: boolean;
  type?: string;
  onSubmit: (comment: string) => void;
}> = ({
  isVisible = true,
  canMessage = true,
  isModerator = false,
  type = 'default',
  isLoading,
  comments = [],
  onSubmit,
}) => {
  const { data: user } = useCurrentUser();
  const { data: { connections } = {} } = useConnections();

  const [comment, setComment] = useState<string>('');
  const [inputError, setInputError] = useState('');
  const inputRef = useRef<any>(null);
  const commentFeedRef = useRef<HTMLIonContentElement | null>(null);

  const scrollContent = () => {
    setTimeout(() => {
      if (commentFeedRef && commentFeedRef.current) {
        commentFeedRef.current.scrollToBottom(300);
      }
    }, 800);
  };

  useEffect(() => {
    scrollContent();
  }, [isVisible, isLoading, comments.length]);

  async function onSubmitComment(e: any) {
    e.preventDefault();
    const formattedComment = replaceSpaces(
      removeUnapprovedEmojis(insertAllowedEmojiPlaceholders(comment))
    );
    if (!formattedComment || formattedComment.length < 3) {
      setInputError('Please enter a longer comment.');
      return;
    }

    if (user) {
      await onSubmit(formattedComment);
    }
    setComment('');
    setInputError('');
  }

  const onPasteText = (e: any) => {
    if (e && e.clipboardData) {
      const pastedText = e.clipboardData.getData('text');
      setComment(` ${pastedText}`);
    }
  };

  const [showPicker, setShowPicker] = React.useState(false);
  const handleClean = () => {
    setComment('');
  };
  const handleSelectEmoji = (emoji: any) => {
    setComment((old) => old + emoji.native);
    setShowPicker(false);
  };

  return (
    <Flex
      flexDir="column"
      justifyContent="space-between"
      h="full"
      className={`chat-${type}`}
    >
      {type !== 'sonar' && type !== 'prompt' && (
        <header>
          <Flex color="black" fontWeight={800} align="center" p={6}>
            Comments
          </Flex>
        </header>
      )}
      {isLoading && (
        <Spinner
          thickness="3px"
          speed="0.5s"
          emptyColor="gray.200"
          color="blue.500"
          position="absolute"
          top="0"
          right="0"
          zIndex={4}
          size="xl"
          m="10px 20px 0"
          style={{
            ['--spinner-size' as any]: '2.2rem',
          }}
        />
      )}
      <Flex flexDir="column" h="full" px={6} py={2}>
        {!isLoading && (
          <>
            {console.log(comments)}
            {comments.map((item) => (
              <Flex color="gray.700" mb={4} key={item.id} textAlign="start">
                <Avatar
                  size="sm"
                  src={item.user.avatar}
                  name={item.user.username}
                />
                <Flex flexDir="column" ml={4}>
                  <Text fontSize={14} fontWeight={700}>
                    {item.user.username}:
                  </Text>
                  <Text fontSize={12} mt={0.5} fontWeight={500}>
                    {item.comment}
                  </Text>
                </Flex>
              </Flex>
            ))}
            {!comments.length && (
              <Flex
                flexDir="column"
                alignItems="center"
                gap={2}
                color="darkBlue.500"
              >
                <ChakraIcon as={BsChatFill} fontSize={24} />
                No one has commented yet.. get the conversation started!
              </Flex>
            )}
          </>
        )}
      </Flex>
      <AddCommentInputError
        className={`input-error ${
          inputError && inputError.length ? 'visible' : ''
        }`}
      >
        {inputError}
      </AddCommentInputError>
      <Flex flexDir="column" p={4}>
        {canMessage ? (
          <Flex flexDir="column" gap={4}>
            {type === 'prompt' ? (
              <form onSubmit={onSubmitComment}>
                <FormControl>
                  <BlgInput
                    placeholder="Leave your comment here..."
                    pr={100}
                    value={comment}
                    onChange={(e) =>
                      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                      setComment(e.target.value!)
                    }
                  />
                  <InputRightElement
                    display="flex"
                    alignItems="center"
                    h="full"
                    pr={2}
                  >
                    {showPicker && (
                      <Box
                        position="absolute"
                        bottom={8}
                        right={0}
                        zIndex="1000"
                        onMouseLeave={() => setShowPicker(false)}
                      >
                        <Picker onSelect={handleSelectEmoji} />
                      </Box>
                    )}
                    <IconButton
                      onClick={handleClean}
                      size="sm"
                      fontSize={20}
                      aria-label="cancel message"
                      icon={<FiX />}
                      variant="ghost"
                      borderRadius="full"
                    />
                    <IconButton
                      onClick={onSubmitComment}
                      size="sm"
                      fontSize={16}
                      aria-label="Send message"
                      icon={<FiSend />}
                      variant="ghost"
                      borderRadius="full"
                    />
                    {/* <IconButton
                    size="sm"
                    fontSize={16}
                    onClick={() => setShowPicker((val) => !val)}
                    aria-label="emoji message"
                    icon={<BsEmojiSmile />}
                    variant="ghost"
                    borderRadius="full"
                  /> */}
                  </InputRightElement>
                </FormControl>
              </form>
            ) : (
              <>
                <Textarea
                  spellcheck
                  minlength={2}
                  maxlength={140}
                  bg="gray.50"
                  type="text"
                  enterkeyhint="send"
                  ref={inputRef}
                  value={comment}
                  fontSize={14}
                  placeholder="Leave your comment here..."
                  clearInput
                  onKeyPress={($event) =>
                    $event.key === 'Enter' && onSubmitComment($event)
                  }
                  onPaste={(e) => onPasteText(e)}
                  onChange={(e) =>
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    setComment(e.target.value!)
                  }
                />
                <Flex justifyContent="end">
                  <BlgButton
                    aria-label="Submit comment"
                    onClick={onSubmitComment}
                    colorScheme="darkBlue"
                    mr={2}
                    pl={3}
                    pr={4}
                    size="sm"
                    leftIcon={<ChakraIcon fontSize={16} as={FiArrowRight} />}
                  >
                    Submit
                  </BlgButton>
                </Flex>
              </>
            )}
          </Flex>
        ) : (
          <Flex justify="center" fontWeight="normal" w="full" align="center">
            <ChakraIcon boxSize={6} mr={3} color="red.500" as={BiBlock} />
            You have been muted in this group.
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};
